
  export class consumerDetailsObject {
    "transactionId":String;
    "applicationNumber":String;
    "consumerId":String;
    "applicationDate":String;
    "applicantName":String;
    "inspectionDate":String;
    "estimatedDate":String;
    "emdAmount":String;
    "emdAmountPaid":String;
    "emdAmountPaymentDate":String;
    "esmatedAmount":String;
    "netAmount":String;
    "status":String;
    "netAmountPaid":String;
    "netAmountPaymentDate":String;
    "onHold":String;
    "noOfUploadDoc":number;
    "htConsumerPaymentStatus":number;
    "appReceived":string;
    "emdPaid":string;
    "techSurvey":string;
    "quotationGenerated":string;
    "payByConsumer":string;
    "workStartExecution":string;
    "workCompletedExecution":string ;
    "energised":string;

  }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/ConsumerDetailsObject/ConsumerDetailsObject.ts